import { render, staticRenderFns } from "./HomeDocumentationCollection.vue?vue&type=template&id=22cd89ba&"
import script from "./HomeDocumentationCollection.vue?vue&type=script&lang=js&"
export * from "./HomeDocumentationCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports